module.exports = __webpack_public_path__ + "static/media/laugh-squint.74bd43aa.svg";